export function slugify(title, wordLimit = 5) {
  return title
    .split(/\s+/)
    .slice(0, wordLimit)
    .join(" ")
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");
}
